<template>
  <div>
    <a-row class="mb-20" style="margin-bottom: 20px">
      <a-col :xs="24" :sm="24" :md="6">
        <a-input-search
          style="width: 100%"
          :placeholder="$t('productManager.search')"
          enter-button
          @search="onSearch"
        />
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 4, offset: 1}">
        <a-select
          style="width: 100%"
          :v-decorator="['category_id']"
          :allow-clear="true"
          :placeholder="$t('productManager.selectCategory')"
          @change="handleChangeCategory"
        >
          <a-select-option v-for="category in categories" :key="category.id">
            {{ category.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 4, offset: 1}">
        <a-select
          style="width: 100%"
          :v-decorator="['brand_id']"
          :allow-clear="true"
          :placeholder="$t('productManager.selectBrand')"
          @change="handleChangeBrand"
        >
          <a-select-option v-for="brand in brands" :key="brand.id">
            {{ brand.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="24" :sm="24" :md="{span: 2, offset: 5}">
        <a-button type="primary" icon="plus" @click="handleCreate">
          {{ $t('table.create') }}
        </a-button>
      </a-col>
    </a-row>
    <a-divider />
    <a-row>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="record">
          <a-button type="primary" icon="form" size="small" @click="handleEdit(record)">{{ $t('table.update') }}</a-button>
          <a-divider type="vertical" />
          <a-button type="danger" icon="delete" size="small" @click="confirmDelete(record)">{{ $t('table.delete') }}</a-button>
        </span>
      </a-table>
    </a-row>
    <AddEditModal ref="refModal" @updateProductSuccess="handleUpdateProductSuccess" />
  </div>
</template>

<script>
import {
  SearchProduct as ApiSearchProduct,
  DestroyProduct as ApiDestroyProduct
} from '@/api/products';
import AddEditModal from './AddEditModal.vue';
import { SearchCategory as ApiSearchCategory } from '@/api/categories';
import { SearchBrand as ApiSearchBrand } from '@/api/brands';

export default {
  name: 'Products',
  components: {
    AddEditModal
  },
  data() {
    const columns = [
      {
        dataIndex: 'name',
        title: () => this.$t('productManager.column.name'),
        key: 'name'
      },
      {
        dataIndex: 'category_name',
        title: () => this.$t('productManager.column.category_name'),
        key: 'category_name'
      },
      {
        dataIndex: 'brand_name',
        title: () => this.$t('productManager.column.brand_name'),
        key: 'brand_name'
      },
      {
        dataIndex: 'group_name',
        title: () => this.$t('productManager.column.group_name'),
        key: 'group_name'
      },
      {
        dataIndex: 'color_name',
        title: () => this.$t('productManager.column.color_name'),
        key: 'color_name'
      },
      {
        dataIndex: 'gender_name',
        title: () => this.$t('productManager.column.gender_name'),
        key: 'gender_name'
      },
      {
        dataIndex: 'state_name',
        title: () => this.$t('productManager.column.state_name'),
        key: 'state_name'
      },
      {
        dataIndex: 'size',
        title: () => this.$t('productManager.column.size'),
        key: 'size'
      },
      {
        dataIndex: 'price',
        title: () => this.$t('productManager.column.price'),
        key: 'price'
      },
      {
        dataIndex: 'description',
        title: () => this.$t('productManager.column.description'),
        key: 'description'
      },
      {
        dataIndex: 'image',
        title: () => this.$t('productManager.column.image'),
        key: 'image'
      },
      {
        title: this.$t('table.action'),
        key: 'action',
        width: '200px',
        scopedSlots: { customRender: 'action' }
      }
    ];
    return {
      columns,
      data: [],
      categories: [],
      brands: [],
      pagination: { current: 1, pageSize: 15 },
      filter: {},
      params: {},
      loading: false,
      form: this.$form.createForm(this)
    };
  },
  created() {
    this.handleSearch();
    this.getCategorys();
    this.getBrands();
  },
  methods: {
    onSearch(value) {
      this.filter.name = value;
      this.handleSearch();
    },
    handleChangeCategory(value) {
      this.filter.category_id = value;
      this.handleSearch();
    },
    handleChangeBrand(value) {
      this.filter.brand_id = value;
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.params.filter = this.filter || {};
      this.params.page = this.pagination.current || 1;
      ApiSearchProduct(this.params)
        .then((response) => {
          const { data, pagination } = response;
          this.data = data;
          this.pagination = {
            total: pagination.total,
            pageSize: pagination.perPage,
            current: pagination.currentPage
          };
          this.loading = false;
        })
        .catch(() => { this.loading = false; });
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.handleSearch();
    },
    handleCreate() {
      this.$refs.refModal.showModal();
    },
    handleEdit(row) {
      this.$refs.refModal.showModal(row.id);
    },
    handleUpdateProductSuccess() {
      this.handleSearch();
    },
    confirmDelete(record) {
      this.$confirm({
        title: this.$t('modal.confirmDelete.question'),
        okText: this.$t('modal.confirmDelete.ok'),
        cancelText: this.$t('modal.confirmDelete.cancel'),
        onOk: () => {
          const { id } = record;
          ApiDestroyProduct({ id })
            .then(() => {
              this.$notification.success({ message: this.$t('modal.successMessage.deleteSuccess') });
              this.searchProduct();
            })
            .catch(() => {
              this.$notification.error({ message: this.$t('modal.faildMessage.deleteFaild') });
            });
        }
      });
    },
    getCategorys() {
      this.loading = true;
      ApiSearchCategory()
        .then((response) => {
          const { data } = response;
          this.categories = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBrands() {
      this.loading = true;
      ApiSearchBrand()
        .then((response) => {
          const { data } = response;
          this.brands = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
